import { Stack } from "@mui/material";
import React from "react";

export const MessagesDialogWrapper: React.FC<{ children: React.ReactNode }> = (
  props
) => {
  return (
    <Stack
      direction={"row"}
      spacing={0.75}
      alignItems="center"
      sx={{ minWidth: 0, width: "100%" }}
    >
      {props.children}
    </Stack>
  );
};
